// Global
import React from 'react';

// Local
import { RecipeResponse } from 'lib/services/models/content-response';
import CtaLink from 'components/helpers/Atoms/Cta/CtaLink';
import styles from './RecipeDownloadTemplate.module.scss';
import useDictionary from 'lib/hooks/useDictionary';

export interface RecipeDownloadTemplateProps {
  recipe?: RecipeResponse;
}

export function RecipeDownloadTemplate(props: RecipeDownloadTemplateProps) {
  const { recipe } = props;

  const { getDictionaryValue } = useDictionary();

  if (!recipe) {
    return null;
  }
  const templateItem = recipe?.KitchenTips?.find((i) => i.Category === 'Templates and Diagrams');
  if (!templateItem) return null;

  const match = templateItem.Description.match(/<a href="([^"]+)">(.*?)<\/a>/);
  if (!match) return null;

  const [, rawUrl, text] = match;

  const url =
    rawUrl.startsWith('http://') || rawUrl.startsWith('https://') ? rawUrl : `https://${rawUrl}`;

  const finalText = text && text.trim() ? text : 'Download Template';
  const finalTextInclPdf = finalText + ' (PDF)';
  return (
    <div className={styles.diagramTemplateDownload}>
      <h2 className={styles.diagramTitle}>
        {getDictionaryValue('Components.Recipe.DiagramTemplateDownload.Diagram')}
      </h2>
      <CtaLink
        download
        url={url}
        text={finalTextInclPdf}
        ctaVariant={'brand'}
        ctaStyle={'outline'}
        target="_blank"
        ctaIconBefore="jump-to"
        ctaIconSize="sm"
        suppressNewTabIcon
      />
      <div></div>
    </div>
  );
}
